import axios from 'axios';

const cdnNexonstatic = axios.create({
	baseURL: `//${process.env.VUE_APP_CDN_NEXONSTATIC}/cms/v1/`,
});
// convert all cdn image's relative path to absolute path
const _convertObject = (data) => {
	if (typeof data !== 'object' || !data) return data;
	Object.keys(data).forEach((key) => {
		const value = data[key];
		if (typeof value === 'object') {
			return _convertObject(value);
		}
		if (typeof value === 'string' && value.startsWith('/media')) {
			data[key] = `//${process.env.VUE_APP_CDN_NEXONSTATIC.replace('pre.', '')}${value}`;
		}
	});
};

cdnNexonstatic.interceptors.response.use((response) => {
	_convertObject(response.data);
	return response;
});

export default cdnNexonstatic;
